/**
 * ¿El usuario en sesión puede usar el permiso `identifier`? Lo mismo que decide el candado del
 * middleware (`CrmStaffPermission`), leído de `crm/staffs/me`:
 *
 * - súper admin, dueño (legacy o de tenant) → todo;
 * - perfil de acceso completo → el backend ya manda en `permissions` todo lo de la marca;
 * - perfil personalizado → `permissions` trae lo asignado MÁS las lecturas de apoyo que eso abre
 *   (config/permission_urls.php → apoyo).
 *
 * Sirve para NO pedir lo que el perfil no tiene (y no pintar una tarjeta rota con un 403), no para
 * proteger nada: la autorización real sigue en el backend.
 */
export interface UsuarioConPermisos {
  is_super_admin?: boolean | number | null
  is_owner?: boolean | number | null
  role?: string | null
  permissions?: unknown
}

export function puede(user: UsuarioConPermisos | null | undefined, identifier: string): boolean {
  if (!user) return false
  if (user.is_super_admin || user.is_owner || user.role === "owner_tenant") return true
  // Un /me sin lista (backend viejo o respuesta rara): no esconder nada, que decida el backend.
  if (!Array.isArray(user.permissions)) return true
  return (user.permissions as unknown[]).includes(identifier)
}

/** Alguno de los permisos. */
export function puedeAlguno(user: UsuarioConPermisos | null | undefined, identifiers: string[]): boolean {
  return identifiers.some((id) => puede(user, id))
}

/** Evento que avisa "el backend negó un permiso": useUser vuelve a leer menú y permisos. */
export const PERMISO_DENEGADO_EVENT = "crm:permiso-denegado"
